import React from 'react';
import { ButtonGroup } from '~/lib/bn-material-ui';

export default function BnButtonGroup({ value, onClick, children, ...props }) {
  return (
    <ButtonGroup size='small' {...props}>
      {React.Children.map(children, child => {
        if (!React.isValidElement(child)) {
          return child;
        }
        return React.cloneElement(child, {
          variant: value === child.props.value ? 'contained' : 'outlined',
          onClick: () => onClick(child.props.value),
        });
      })}
    </ButtonGroup>
  );
}
